import { useMutation } from "@tanstack/react-query";
import TenantAPI from "../../api/TenantAPI";
import {
  callFunctionIfExists,
  getErrorMessage,
} from "../../../utils/GeneralUtils";
import { newToastEvent } from "../../../utils/ToastUtil";
import { SavedBulkEmailOperations } from "../../../components/Drawers/EmailBuilderDrawer/EmailBuilderTypes";

interface IndexMutation {
  action: SavedBulkEmailOperations;
  recipients: string[];
  ccs: string[];
  recordID: string;
  GEEventID?: string;
  onSuccess?: () => void;
  onError?: (msg: string) => void;
}

const useSendBulkEmail = () => {
  const sendBulkEmail = useMutation({
    mutationFn: ({
      action,
      recipients,
      ccs,
      recordID,
      GEEventID,
    }: IndexMutation) => {
      const payload: any = {
        To: recipients,
        CC: ccs,
        From: {
          name: action?.From?.name || "GrowthCloud",
          email: action?.From?.email || "noreply@growthcloud.com",
        },
        Subject: action?.Subject,
        Variables: [...(action.Variables || [])],
        Type: action.Type,
        GEEventID: GEEventID,
      };

      if (action.Type === "Custom") {
        payload.Content = action.Content;
      }

      if (action.Type === "Dynamic") {
        payload.TemplateID = action.TemplateID;
        payload.UnsubscribeGroupID = action.UnsubscribeGroupID;
      }

      for (const variable of payload.Variables) {
        if (variable.Type === "RecordDynamic") {
          variable.RecordID = recordID;
        }
      }

      return TenantAPI.sendBulkEmail(payload);
    },

    onSuccess: (data, { onSuccess }) => {
      callFunctionIfExists(onSuccess);
    },
    onError: (error, { onError }) => {
      const errorMessage = getErrorMessage(
        error,
        "An unknown error occurred. Please try again."
      );

      newToastEvent("error", errorMessage);
      onError && onError(errorMessage);
    },
  });

  return {
    sendBulkEmail: sendBulkEmail.mutate,
    sending: sendBulkEmail.isPending,
  };
};

export default useSendBulkEmail;
